import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const FooterNew = () => {
  return (
    <div
      style={{
        backgroundColor: '#1A1F2E',
        color: '#FFFFFF',
        padding: '60px 20px 30px 20px',
        marginTop: '60px',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Grid stackable columns={4}>
          {/* Logo and Tagline */}
          <Grid.Column width={4}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div
                style={{
                  backgroundColor: '#3D6B59',
                  borderRadius: '8px',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '10px',
                }}
              >
                <span style={{ color: 'white', fontSize: '1.5rem' }}>♣</span>
              </div>
              <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Bridgemate</span>
            </div>
            <p style={{ fontSize: '0.9rem', color: '#B0B0B0', lineHeight: '1.6' }}>
              Home for regional bridge results, fixtures and news across Mayo.
            </p>
          </Grid.Column>

          {/* Quick Links */}
          <Grid.Column width={3}>
            <h4 style={{ marginBottom: '15px', fontSize: '1rem' }}>Quick Links</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <Link to="/events/results" style={{ color: '#B0B0B0', textDecoration: 'none' }}>
                Results
              </Link>
              <Link to="/events" style={{ color: '#B0B0B0', textDecoration: 'none' }}>
                Fixtures
              </Link>
              <Link to="/news" style={{ color: '#B0B0B0', textDecoration: 'none' }}>
                News
              </Link>
              <a href="#clubs" style={{ color: '#B0B0B0', textDecoration: 'none' }}>
                Clubs
              </a>
            </div>
          </Grid.Column>

          {/* Contact */}
          <Grid.Column width={3}>
            <h4 style={{ marginBottom: '15px', fontSize: '1rem' }}>Contact</h4>
            <a
              href="mailto:donalireland@gmail.com"
              style={{ color: '#B0B0B0', textDecoration: 'none' }}
            >
              donalireland@gmail.com
            </a>
          </Grid.Column>

          {/* Information */}
          <Grid.Column width={6}>
            <h4 style={{ marginBottom: '15px', fontSize: '1rem' }}>Information</h4>
            <p style={{ fontSize: '0.85rem', color: '#B0B0B0', lineHeight: '1.6' }}>
              We comply with GDPR regulations. All members of Bridge Clubs complete membership
              forms to ensure data protection compliance.
            </p>
            <Link to="#" style={{ color: '#4A7C67', textDecoration: 'none', fontSize: '0.9rem' }}>
              Privacy Policy →
            </Link>
          </Grid.Column>
        </Grid>

        {/* Copyright */}
        <div
          style={{
            borderTop: '1px solid #333',
            marginTop: '40px',
            paddingTop: '20px',
            textAlign: 'center',
            fontSize: '0.85rem',
            color: '#888',
          }}
        >
          © 2025 Bridgemate.ie · Mayo Bridge Clubs
        </div>
      </div>
    </div>
  );
};

export default FooterNew;
